import { Account } from '@core/model/domain/account';
import { OkVal } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import type { AccountService } from '@core/model/service/accountService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type GetAccountsInput = {
  userToken: string;
  userId: string;
  connectionId: string;
};
export type GetAccountOutput = Promise<OkVal<Account[]>>;

@injectable()
export class GetAccounts implements Usecase<GetAccountsInput, GetAccountOutput> {
  constructor(
    @inject(SERVICE_ID.accountService)
    private readonly accountService: AccountService
  ) {}

  async execute(cmd: GetAccountsInput): GetAccountOutput {
    return await this.accountService.getAccounts(cmd);
  }
}
